import "./eventApplication.css";
import bgFilter from "./assets/bgFilter.svg";
import { useEffect, useState, useMemo } from "react";
import category from "./assets/category.svg";
import date from "./assets/date.svg";
import opening from "./assets/opening.svg";
import posted from "./assets/posted.svg";
import RectangleImg from "./assets/RectangleImg.svg";
import ekalakaa from "./assets/ekalakaa.svg";
import locationArt from "./assets/location.svg";
import phone from "./assets/phone.svg";
import instagram from "./assets/instagram.svg";
import facebookimg from "./assets/facebookimg.svg";
import DP from "./assets/DP.svg";
import anvelop from "./assets/anvelop.svg";
import eventBg from "./assets/eventBg.jpg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { makeAuthenticatedGETRequest, makeAuthenticatedPATCHRequest, makeAuthenticatedPOSTRequest } from "../../services/serverHelper";
import { useSelector } from "react-redux";
import { patronProfilePoints } from "../../services/apis";
import { toast } from 'react-toastify';
  import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
import noAppli from "./assets/no_uploaded_oppor.svg"
import NoDataTemplate from "../../ArtisitPages/StatusOfApplication/NoDataTemplate";
import Patron_Navbar from "../Patron_Navbar";
import { FaPhone, FaEnvelope, FaLocationArrow } from "react-icons/fa";
import locationC from "./assets/locationC.svg";
import dateOfPerformance from "./assets/dateOfPerformance.svg";
import amount from "./assets/amount.svg";
import language from "./assets/language.svg";
import appliDueDate from "./assets/applicationDueDate.svg";
import PatronSidebar from "../PatronSidebar";


function EventApplication() {

  const navigate = useNavigate();
  
  const [currentEvent, setCurrentEvent] = useState("All");
  
  const {accessToken} = useSelector((state)=>state.auth);

  const location = useLocation();

  // this is to store the application of an opportunity 
  const [artistApplication , setArtistApplication] = useState([]);

  const [filteredApplication, setFilteredApplication] = useState([]);
  // THIS IS FOR SHORTLIST application
  const [shortlistApplication , setShortlistApplication] = useState([]);

  // this is to set the hired application
  const [hiredApplication , setHiredApplication] = useState([]);

  // this is to get the id of fetching the application of an opportunity from path
  const {id} = useParams();
  
  // this is for getting the opportunity data in object form 
  const opportunityData = location.state?.dataObj;

  const appli_Data = [
    {
      img:locationC,
      title: "Location of Performance :",
      value:opportunityData?.location?.state
    },
    {
      img: language,
      title: "Language of Performance :",
      value:opportunityData?.language
    },
    {
      img: amount,
      title: "Amount :",
      value:opportunityData?.budget
    },
    {
      img: dateOfPerformance,
      title: "Date of Performance :",
      value:opportunityData?.performanceDate.slice(0, 10)
    },
    {
      img: dateOfPerformance,
      title: "Duration of Performance :",
      value:opportunityData?.performanceDuration
    },
    {
      img: appliDueDate,
      title: "Application Due Date :",
      value:opportunityData?.applicationPeriod?.end.slice(0,10)
    },
  ];



  // ! this function is to fetch the application 
  const fetchArtistApplication = async()=>{
    try{
          const response = await makeAuthenticatedGETRequest(patronProfilePoints.GET_SINGLE_OPPOR_ALL_APPLIED_ARTIST_APPLI_API +`${id}` , accessToken);
          console.log('fetchappli' , response.data);
          if(response.status === 'success'){
            setArtistApplication(response.data);   
            setFilteredApplication(response.data);       
          }
          else{
            toast.error(response.message);
          }

        } catch(error){
          console.log(error);
          toast.error('Something went wrong , please try again');
        }
  }

  // ! THIS Is to fetch the all inprogress or shortlist application 
  const fetchInProgressApplication = async()=>{
    try{
            const response = await makeAuthenticatedGETRequest(patronProfilePoints.GET_SINGLE_OPPOR_ALL_IN_PROGRESS_ARTIST_APPLI_API +`${id}` , accessToken);
        console.log('inprof' , response);
        if(response.status === 'success'){
          setShortlistApplication(response.data);
        }
        else{
          toast.error(response.message);
        }

      } catch(error){
        console.log(error);
        toast.error('Something went wrong , please try again');
      }
  }


  // this is to fetch the hired application 
  const fetchHiredApplication = async()=>{
    try{
            const response = await makeAuthenticatedGETRequest(patronProfilePoints.GET_SINGLE_OPPOR_ALL_HIRED_ARTIST_APPLI_API +`${id}` , accessToken);
      console.log('hired' , response);
      if(response.status === 'success'){
        setHiredApplication(response.data);
      }
      else{
        toast.error(response.message);
      }

    } catch(error){
      console.log(error);
      toast.error('Something went wrong , please try again');
    }
  }

  const handleShortListing = async(id)=>{
    const response = await makeAuthenticatedPOSTRequest(
      `${patronProfilePoints.SHORTLIST_APPLI_API}/${id}`,
      {status: "Shortlisted"},
      accessToken
    )

    if(response.statusCode === 200){
      toast.success('Artist shorlisted.');
      console.log('Artist Shorlisted');
    }else{
      console.log(response);
    }
  }


  const handleHiring = async(appliId)=>{
    const response = await makeAuthenticatedPATCHRequest(
      `${patronProfilePoints.HIRED_APPLI_API}`,
      {status: "Hired", opportunityId: id, id: appliId},
      accessToken
    )

    if(response.statusCode === 200){
      toast.success('Artist hired.');
      console.log('Artist Hired');
    }else{
      toast.error("Error.");
      console.log(response);
    }
  }

  const handleRejection= async(id)=>{
    const response = await makeAuthenticatedPOSTRequest(
      `${patronProfilePoints.SHORTLIST_APPLI_API}/${id}`,
      {status: "Rejected"},
      accessToken
    )

    if(response.statusCode === 200){
      toast.success('Artist Rejected.');
      console.log('Artist Rejected');
    }else{
      console.log(response);
    }
  }

  const filteredApplications = useMemo(() => {
    if (currentEvent === "All") {
      return artistApplication;
    }

     return artistApplication.filter((item) => item?.status === currentEvent
      );
      // console.log("Filter data: ", filterdata)
  }, [artistApplication, currentEvent]);

  // this useEffect is to call the api on basic of current event
  useEffect(()=>{

    fetchArtistApplication();
    
    console.log(filteredApplication)

  },[])


  return (
    <>
    <Patron_Navbar/>
    <div className="dashboard-layout">
      <PatronSidebar />
      <div className="patron_event_appli_wrapper">
        {/* image section */}
        <section className="event_image_section">
          <p className="event_application_text">
            Event Application for {opportunityData?.artName}
          </p>
        </section>

        {/* job description */}
        <section className="patron_job_description_wrapper">
          {/* left side */}
          <div className="job_description_container">
          <h1 className="job_description_text" style={{color:"#AD2F3B",margin:"5px 0"}}>{opportunityData?.artName}</h1>
            <p className="job_description_text" style={{opacity:"70%",color:"#000000"}}>{opportunityData?.description}</p>
            {/*<p className="job_description_text">Location - {opportunityData?.location}</p>
            <p className="job_description_text">Language - {opportunityData?.languages}</p>
            <p className="job_description_text">Amount - {opportunityData?.budget}</p>
            <p className="job_description_text">Date of Performance  - {opportunityData?.performanceDate.slice(0, 10)}</p>
            <p className="job_description_text">Duration of Performance  - {opportunityData?.performanceDuration}</p> */}

            {appli_Data.map((data, index) => (
                            <div
                              key={index}
                              style={{ display: "flex", gap: "10px",margin:"10px 0" }}
                            >
                              <img
                                src={data.img}
                                alt=""
                                style={{
                                  marginBottom: "10px",
                                }}
                              />
                              <p
                                className="applied_appli_title"
                                style={{
                                  color: "rgb(0,0,0,0.7)",
                                  fontWeight: "500",
                                  fontFamily: "Poppins",
                                }}
                              >
                                {data.title}
                              </p>
                              <p
                                className="applied_appli_title"
                                style={{
                                  color: "rgb(0,0,0)",
                                  fontWeight: "500",
                                  fontFamily: "Poppins",
                                }}
                              >
                                {data.value}
                              </p>

                            </div>
                          ))}
          
          
            {/* <p className="job_description_para">{opportunityData?.description}</p> */}
            {/* <ul className="job_des_allList">
              {jobDesList.map((desc, index) => (
                <li className="job_des_list" key={index}>
                  {desc?.title}
                </li>
              ))}
            </ul> */}

            <div className="desc_buttons">
              <button
                  onClick={() => setCurrentEvent("All")}
                  className={`${
                    currentEvent === "All" ? "event_currentBtn" : "event_btn"
                  }`}
                >
                  All
                </button>
              <button
                  onClick={() => setCurrentEvent("Shortlisted")}
                  className={`${
                    currentEvent === "Shortlisted" ? "event_currentBtn" : "event_btn"
                  }`}
                >
                  Shortlisted
                </button>
              <button
                  onClick={() => setCurrentEvent("Hired")}
                  className={`${
                    currentEvent === "Hired" ? "event_currentBtn" : "event_btn"
                  }`}
                >
                  Hired
                </button>
              <button
                  onClick={() => setCurrentEvent("Rejected")}
                  className={`${
                    currentEvent === "Rejected" ? "event_currentBtn" : "event_btn"
                  }`}
                >
                  Rejected
                </button>
            </div>
          </div>

          {/* right side */}
          <div className="job_overview_container">
            <p className="job_overview_text">Job Overview</p>

            <div className="all_job_overview">
            
                <div  className="single_job_overview">
                  <img src={category} alt="" className="single_overview_img" />
                  <p style={{fontWeight:"500" , fontSize:"18px"}} className="single_job_category">Category</p>
                  <p className="single_job_title">{opportunityData?.artCategory}</p>
                </div>

                <div  className="single_job_overview">
                  <img src={posted} alt="" className="single_overview_img" />
                  <p style={{fontWeight:"500" , fontSize:"18px"}} className="single_job_category">Application Posted</p>
                  <p className="single_job_title">{new Date(   opportunityData?.applicationPeriod?.start
                            ).toLocaleDateString("en-US", {
                              day: "numeric",
                              month: "short",
                              year: "numeric",
                            })}</p>
                </div>

                <div  className="single_job_overview">
                  <img src={date} alt="" className="single_overview_img" />
                  <p style={{fontWeight:"500" , fontSize:"18px"}} className="single_job_category">Application Due Date</p>
                  <p className="single_job_title">{new Date(
                              opportunityData?.applicationPeriod?.end
                            ).toLocaleDateString("en-US", {
                              day: "numeric",
                              month: "short",
                              year: "numeric",
                            })}</p>
                </div>

                {/* <div  className="single_job_overview">
                  <img src={opening} alt="" className="single_overview_img" />
                  <p style={{fontWeight:"500" , fontSize:"18px"}} className="single_job_category">Opening</p>
                  <p className="single_job_title">{opportunityData?.requiredArtists}</p>
                </div> */}
              
            </div>
          </div>
        </section>



  {/* ⚠️ when actual data of all application will come , use map funtion and put this section inside it  */}
        {/* user detail box   */}

        {/* ⚠️ for application section  */}
        {(
            artistApplication.length > 0 ? 
              <section className="application_table_section">
                <div className="application_table_wrapper">
                  <table className="application_table">
                    <thead className="application_table_head">
                      <tr className="application_table_row">
                        <th>Artist</th>
                        <th>Art Name</th>
                        <th>Location</th>
                        <th>Quoted Price</th>
                        <th>Applied On</th>
                        <th>Reason</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody className="patron-appli-body">
                      {filteredApplications.map((data , index)=>(
                      <tr className="patron-appli-body-row application_table_row" key={index}>
                        {/* Artist */}
                        <td>
                          <div className="artist_info">
                            <img src={DP} alt="" className="artist_dp" />

                            <div>
                              <p className="artist_name">
                                {data?.appliedBy?.firstName}{" "}
                                {data?.appliedBy?.lastName}
                              </p>

                              <Link to ={`/patron-view-artist/${data?.appliedBy?._id}`} />

                              <p className="artist_category">
                                {data?.appliedBy?.category}
                              </p>
                            </div>
                          </div>
                        </td>

                        {/* Art Name */}
                        <td>{data?.opportunity?.artName}</td>

                        {/* Location */}
                        <td>{data?.appliedBy?.address?.city}</td>

                        {/* Quoted Price */}
                        <td>₹ {data?.quotedPrice}</td>

                        {/* Applied On */}
                        <td>
                          {new Date(data?.appliedOn).toLocaleDateString("en-US", {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          })}
                        </td>

                        {/* Reason */}
                        <td className="reason_column">
                          {data?.answer}
                        </td>

                        {/* Action */}
                        <td className="patron-action-column">
                          <>
                          {
                            currentEvent === "All" && data?.status ==="Applied" ?
                          
                          <>
                                <button
                                  onClick={()=>handleShortListing(data._id)}
                                  style={{display:data?.status === "Applied" ? 'flex': 'none'}}
                                  className="view_profile_btn shortlisted_btn"
                                >
                                  Shortlist
                                </button>
                                <button
                                  onClick={()=>handleRejection(data._id)}
                                  className="view_profile_btn rejected_btn "
                                  style={{display:currentEvent === "Rejected" ? 'none': 'flex'}}
                                >
                                  Reject
                                </button>
                            
                          </> : currentEvent === "All" && data?.status ?
                              <p className={`appli_status ${data?.status === "Shortlisted" ? "shortlisted" : data?.status === "Hired" ? "hired" : "rejected"}`}>
                                {data?.status}
                              </p>
                              :
                          <>
                            <button
                              onClick={()=>handleShortListing(data._id)}
                              style={{display:currentEvent === "Shortlisted"? 'none': 'flex'}}
                              className="view_profile_btn shortlisted_btn"
                            >
                              Shortlist
                            </button>
                            <button
                              onClick={()=>handleHiring(data._id)}
                              style={{display:currentEvent === "Hired" ? 'none': 'flex'}}
                              className="view_profile_btn hired_btn"
                            >
                              Hire
                            </button>
                            <button
                              onClick={()=>handleRejection(data._id)}
                              className="view_profile_btn rejected_btn "
                              style={{display:currentEvent === "Rejected" ? 'none': 'flex'}}
                            >
                              Reject
                            </button></>
                          }
                            
                          </> 
                          
                          
                        </td>
                      </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </section>
      
            :(
              <NoDataTemplate image={noAppli} patronAppli={true} />
            )
          )
      }
              
      </div>
    </div>
    </>
  );
}

export default EventApplication;
